import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentArrowUpFilledSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.333 1.333C25.333 1.333 28 4 28 12v18.667H4V1.333zM9.151 15.147l1.698 1.697 3.95-3.951v10.44H17.2v-10.44l3.951 3.95 1.698-1.697L16 8.3z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentArrowUpFilledSize32Glyph.displayName = 'DocumentArrowUpFilledSize32Glyph';
